// 配置获奖证书

// 添加证书TODO：官网查询在icode_web项目中，复制一份本文件到对应目录下：src/utils/certificationCfg.js
// 需要把图片上传到oss目录下：oss://codingolympics/assets/template/

// 获取各个比赛的组别
export function getGroupName(gameId) {

    // 等级赛
    if (isLevelAssessment(gameId)) {
        return getLvAssessmentName(gameId);
    }

    // 添加证书TODO: 添加模板配置
    switch (gameId) {
        // 2020 年广东赛
        case 44011:
        case 44111:
            return "初级组";
        case 44112:
        case 44012:
            return "中级组";
        case 44113:
        case 44013:
            return "高级组";


        case 701: // 2020年中国区决赛
        case 14001: // 2022年山西预选赛 
        case 44301: // 2022年广东预选赛 & 发明协会
        case 44401: // 2022年广东预选赛（深圳赛区）
        case 22011401: // 山西ICode比赛1月（积木初级组）
        case 22022601: // 山西ICode比赛3月（积木初级组）
        case 22042101: // 2022三秦杯（积木初级组）
        case 22061801: // 2022三秦杯（积木初级组）决赛
            return "积木初级组";


        case 702: // 2020年中国区决赛
        case 14002: // 2022年山西预选赛 
        case 44302: // 2022年广东预选赛 & 发明协会
        case 44402: // 2022年广东预选赛（深圳赛区）
        case 22011402: // 山西ICode比赛1月（积木高级组）
        case 22022602: // 山西ICode比赛3月（积木高级组）
        case 22042102: // 2022三秦杯（积木高级组）
        case 22061802: // 2022三秦杯（积木高级组）决赛
            return "积木高级组";

        case 22071501: // 西安编程向未来（图形化编程小学组）
            return "图形化编程小学组";
        case 22071502: // 西安编程向未来（图形化编程中学组）
            return "图形化编程中学组";
        case 22071511: // 西安编程向未来（Python编程小学组）
            return "Python编程小学组";
        case 22071512: // 西安编程向未来（Python编程中学组）
            return "Python编程中学组";

        case 23032901:
        case 23053201:
            return "小学图形化组";
        case 23032911:
        case 23053211:
            return "小学Python组";
        case 23032912:
        case 23053212:
            return "中学Python组";


        case 2021501: // 2021全球赛
        case 22121001: // 2022全球赛
        case 23093001: // 2023 全球赛
        case 24081801: // 2024 全球赛
            return "Blockly Beginner";
        case 2021502: // 2021全球赛
        case 22121002: // 2022全球赛
        case 23093002: // 2023 全球赛
        case 24081802: // 2024 全球赛
            return "Blockly Advance";
        case 2021511: // 2021全球赛
        case 22121011: // 2022全球赛
        case 23093011: // 2023 全球赛
        case 24081811: // 2024 全球赛
            return "Python Beginner";
        case 2021512: // 2021全球赛
        case 22121012: // 2022全球赛
        case 23093012: // 2023 全球赛
        case 24081812: // 2024 全球赛
            return "Python Advance";
        case 23072701: // 2023云南小学生评级
            return "图形化编程";
        case 23072711: // 2023云南小学生评级
            return "Python编程";

        case 23061801:  // 芒果TV
            return "基础图形组";
        case 23061811: // 芒果TV
            return "基础Python组";
        case 23061812: // 芒果TV
            return "拓展Python组";

        case 23100601:
            return "圖形化初級組";
        case 23100602:
            return "圖形化高級組";
        case 23100611:
            return "Python初級组";
        case 23100612:
            return "Python高級組";

        default:
            return defaultGroupName(gameId);
    }
}

function defaultGroupName(gameId) {
    switch (gameId % 100) {
        case 1:
            return "图形化初级组";
        case 2:
            return "图形化高级组";
        case 3:
        case 11:
            return "Python初级组";
        case 4:
        case 12:
            return "Python高级组";
        default:
            return "ICode编程挑战赛";
    }
}

//检查比赛是否为等级评测
function isLevelAssessment(gameId) {
    // 1级等级评测
    if (gameId == 8001 || gameId == 8002) return true;

    // 2022-08之前的使用原版本
    // if(220800 > gameId) return false;

    let year = 2000 + Math.floor(gameId / 10000);
    let month = Math.floor(gameId % 10000 / 100);
    let mode = Math.floor(gameId % 100 / 10);
    let level = gameId % 10;

    return (2022 <= year && year <= 2029 &&
        1 <= month && month <= 12 &&
        (mode == 0 || mode == 1) &&
        (level <= 5));
}

function getLvAssessmentName(gameId) {
    /**
     * 月赛编号的规则是：年份(2)+月份(2)+模式(1)+可进入的等级(1)
     * 比如 220403 就是：2022年4月三级赛（图形化）
     */
    let mode = Math.floor(gameId % 100 / 10) == 0 ? "图形化" : "Python";
    let level = gameId % 10;

    if (gameId == 8002) { // 1级等级评测
        mode = "Python"
        level = 1;
    }

    return `ICODE ${mode}等级测评（${level}级）`
}

function getLvAssessmentEnName(gameId) {
    /**
     * 月赛编号的规则是：年份(2)+月份(2)+模式(1)+可进入的等级(1)
     * 比如 220403 就是：2022年4月三级赛（图形化）
     */
    let mode = Math.floor(gameId % 100 / 10) == 0 ? "Blockly" : "Python";
    let level = gameId % 10;

    if (gameId == 8002) { // 1级等级评测
        mode = "Python"
        level = 1;
    }

    return `ICODE ${mode} Skill Test (Level ${level})`;
}


export function getGroupEnName(gameId) {
    // 等级赛
    if (isLevelAssessment(gameId)) {
        return getLvAssessmentEnName(gameId);
    }
}

/**
 * 获取各个比赛的证书模板
 * @param {Number} gameType 赛事类型：0-开放平台 || 1-初赛 || 2-决赛 || 3-月赛 || 4-以色列比赛 || 5-免费教材 || 6-付费教材 || 7-付费月赛 || 8-考核课程 || 9-晋级赛
 * @param {Number} gameId 
 * @param {Number} prize 奖励类型 "1": "金奖","2": "银奖","3": "铜奖",16: "明日之星"
 * @param {Number} type 证书类型。API返回字段实为certificateType，(0-个人，1-老师，2-组织)
 * @returns {String} 
 */
export function getTemplate(gameType, gameId, prize, type) {

    // 裁判证书 prize = 902
    const RefereeTemplate = {
        "20220001": "referee_20220001.png", // 2022中国区决赛裁判员证书
    }

    if (type == 1 && prize == 902) return RefereeTemplate[gameId];


    // 901 优秀指导教师
    const TeacherTemplate = {
        "20220001": "teacher_220326.png",
        "22122401": "221224_Teacher.jpg",
        "23030000": "23030401_Teacher.jpg", // 2023年第五届ICode中国区预选赛
        "23052600": "hnai2023Teacher.png", //2023年湖南人工智能学会比赛决赛
        "23070000": "teacher_23070000.jpg", // 2023年第五届ICode中国区决赛
        "23093001": "teacher_23093001.jpg", // 2023年第五届全球决赛
        "24010000": "teacher_24010000.jpg", // 2024年第六届ICode中国区预选赛
        "24055500": "teacher_24055500.png", // 2024年第六届ICode中国区决赛
        "24081801": "teacher_24081801.jpg", // 2024 全球决赛
        // 芒果TV 3个组别分别发优秀指导教师
        "23061801": "mgtv_2023_teacher.jpg", // 芒果TV
        "23061811": "mgtv_2023_teacher.jpg", // 芒果TV
        "23061812": "mgtv_2023_teacher.jpg", // 芒果TV
    }
    if (type == 1) return TeacherTemplate[gameId] || `teacher_${gameId}.jpg`;

    // 优秀组织奖
    const OrgTemplate = {
        "20220001": "org_220326.png",
        "22122401": "221224_Org.jpg",
        "23030000": "23030401_Org.jpg", // 2023年第五届ICode中国区预选赛
        "23052600": "hnai2023School.png", //2023年湖南人工智能学会比赛决赛
        "23070000": "org_23070000.jpg", // 2023年第五届ICode中国区决赛
        "24010000": "org_24010000.png", // 2024年第六届ICode中国区预选赛
        "24055500": "org_24055500.png", // 2024年第六届ICode中国区决赛
        "24070900": "org_24070900.png", // 2024年青科赛
    }

    if (type == 2) return OrgTemplate[gameId];


    // 一级测评
    // prize
    // 19	19	全球卓越奖1%
    // 20	20	全球优秀奖5%
    // 21	21	全球荣誉奖25%
    // 22	22	全球晋级奖50%
    // 23	23	全球参与奖
    if (gameType == 9 && isLevelAssessment(gameId) && prize >= 19 && prize <= 23) {
        return "level_accessment_4.png";
    }

    // 2 ~ 5级测评
    if (gameType == 3 && isLevelAssessment(gameId) && prize >= 19 && prize <= 23) { // 从2022年8月开始启用新的证书模版
        return {
            19: "level_accessment_1.png", // top 1% 金奖
            20: "level_accessment_2.png", // top 5% 银奖
            21: "level_accessment_3.png", // top 25% 铜奖
            22: "level_accessment_4.png", // 通过 top 50% 晋级 （明日之星）
            23: "level_accessment_5.png", // 参与奖 
        }[prize];
    }

    // 添加证书TODO: 添加模板配置
    let eventCode = Math.floor(gameId / 100); // 正常是去掉右边2位

    switch (eventCode) {

        case 230304: // ICode 2023 全国预选赛 I
        case 230319: // ICode 2023 全国预选赛 II
        case 230408: // ICode 2023 全国预选赛 III
        case 230423: // ICode 2023 全国预选赛 IV
        case 230508: // ICode 2023 全国预选赛 V
        case 230521: // ICode 2023 全国预选赛 VI
            return { 1: "ICode2023P_Gold.png", 2: "ICode2023P_Silver.png", 3: "ICode2023P_Bronze.png", 16: "ICode2023P_Star.png" }[prize];

        case 220326: // ICode 2022 全国预选赛 I
        case 220416: // ICode 2022 全国预选赛 II
        case 220423: // ICode 2022 全国预选赛 III
        case 220514: // ICode 2022 全国预选赛 IV
        case 220528: // ICode 2022 全国预选赛 V
        case 220611: // ICode 2022 复活赛
            return { 1: "ICode2022Gold.png", 2: "ICode2022Silver.png", 3: "ICode2022Bronze.png", 16: "ICode2022Star.png" }[prize];

        case 231104: // ICode 2024 全国预选赛 I - VII
        case 231118:
        case 231202:
        case 231216:
        case 240102:
        case 240120:
        case 240218:
        case 240323:
            return { 1: "ICode2024P_Gold.png", 2: "ICode2024P_Silver.png", 3: "ICode2024P_Bronze.png", 16: "ICode2024P_Star.png" }[prize];

        case 220723: // ICode 2022 中国区决赛
            return { 1: "ICode2022FinalGold.png", 2: "ICode2022FinalSilver.png", 3: "ICode2022FinalBronze.png", 16: "ICode2022FinalStar.png" }[prize];

            
        case 140: // 2022年山西预选赛 
        case 220114: // 2022年山西预选赛 第二轮
        case 220226: // 2022年山西预选赛 第三轮
        case 220418: // 2022年山西预选赛 第四轮
        case 220515: // 2022年山西预选赛 第五轮
            return { 1: "shanxi2022-1.png", 2: "shanxi2022-2.png", 3: "shanxi2022-3.png", 16: "shanxi2022-4.png" }[prize];

            // 2022年三秦杯
        case 220421:
            return { 1: "sanqin_1.png", 2: "sanqin_2.png", 3: "sanqin_3.png", 16: "sanqin_16.png" }[prize];

        case 220618: // 2022年三秦杯决赛
            return { 1: "sanqin_final_1.png", 2: "sanqin_final_2.png", 3: "sanqin_final_3.png", 16: "sanqin_final_16.png" }[prize];

        case 220715: // 西安编程向未来活动
            return { 1: "220715G.jpg", 2: "220715S.jpg", 3: "220715B.jpg" }[prize];

            // 2022年广东预选赛 & 发明协会
        case 443:

            // 2022年广东预选赛（深圳赛区）
        case 444:
            return { 1: "GD202201.png", 2: "GD202202.png", 3: "GD202203.png", 16: "GD202204.png" }[prize];

            // 2021年全球赛
        case 20215:
            return "2021GlobalFinal.png";

        case 7:
            return { 1: "v2020080801.png", 2: "v2020080802.png", 3: "v2020080803.png", 16: "v2020080804.png" }[prize];

            // 上海小学生信奥
        case 3100:
            return "sh202112python.jpg";

            // 2022年西安智慧编程选拔赛
        case 221032:
            if (gameId == 22103201) {
                return { 1: "shx22103201A.jpg", 2: "shx22103201B.jpg", 3: "shx22103201C.jpg" }[prize];
            } else if (gameId == 22103202) {
                return { 1: "shx22103202A.jpg", 2: "shx22103202B.jpg", 3: "shx22103202C.jpg" }[prize];
            } else if (gameId == 22103211) {
                return { 1: "shx22103211A.jpg", 2: "shx22103211B.jpg", 3: "shx22103211C.jpg" }[prize];
            } else {
                return { 1: "shx22103212A.jpg", 2: "shx22103212B.jpg", 3: "shx22103212C.jpg" }[prize];
            }
            // 2022年西安智慧编程决赛
        case 221224:
            if (gameId == 22122401) {
                return { 1: "shx22122401A.jpg", 2: "shx22122401B.jpg", 3: "shx22122401C.jpg" }[prize];
            } else if (gameId == 22122402) {
                return { 1: "shx22122402A.jpg", 2: "shx22122402B.jpg", 3: "shx22122402C.jpg" }[prize];
            } else if (gameId == 22122411) {
                return { 1: "shx22122411A.jpg", 2: "shx22122411B.jpg", 3: "shx22122411C.jpg" }[prize];
            } else {
                return { 1: "shx22122412A.jpg", 2: "shx22122412B.jpg", 3: "shx22122412C.jpg" }[prize];
            }
            // 2022全球赛
        case 221210:
            return { 1: "GlobalFinal2022_Gold.png", 2: "GlobalFinal2022_Silver.png", 3: "GlobalFinal2022_Bronze.png", 16: "GlobalFinal2022_Participation.png" }[prize];
            // 第一届湖南人工智能编程挑战赛
        case 230103:
            return { 1: "hnai2023Gold.png", 2: "hnai2023Silver.png", 3: "hnai2023Bronze.png" }[prize];
            // 2023湖南青科赛模拟赛
        case 230329:
            return { 1: "hn2023Gold.png", 2: "hn2023Silver.png", 3: "hn2023Bronze.png", 4: "hn2023Star.png" }[prize];
            // 2023新春赛
        case 221226:
            return "spring_certificate.png";
            // 2023湖南省人工智能学会比赛 0522半决赛 0526决赛
        case 230522:
        case 230526:
            return { 1: "hnai2023PersonalA.png", 2: "hnai2023PersonalB.png", 3: "hnai2023PersonalC.png", 16: "hnai2023PersonalS.png" }[prize];
        case 230532: // 2023南京选拔赛
            return "nanjing_2023.png";
        case 230624:
            return "nanjing_2023p.png";
        case 230715: // ICode 2023 全国决赛
            return { 1: "ICode2023F_Gold.png", 2: "ICode2023F_Silver.png", 3: "ICode2023F_Bronze.png", 16: "ICode2023F_Star.png" }[prize];
        // case 240555: // 2024年第六届ICode中国区总决赛
        //     return { 1: "CERT_240555_1.png", 2: "CERT_240555_2.png", 3: "CERT_240555_3.png" }[prize];
        case 230727: // 2023云南小学生评级
            return { 1: "xxs2023_A.png", 2: "xxs2023_B.png", 3: "xxs2023_C.png", 16: "xxs2023_D.png", 4: "xxs2023_E.png" }[prize];
        case 230819:
            return "ICodeMaster2023.png";
        case 230618: // 芒果TV，证书从 mgtv_2023_1 - mgtv_2023_11, mgtv_2023_16
            return `mgtv_2023_${prize}.jpg`;
        case 230506:
        case 230930: // 2023 全球赛
        case 230919: // 浙江亚运活动
        case 231204: // 浙江亚运活动决赛
            return `CERT_${eventCode}_${prize}.jpg`;
        case 230302: // 河源市首届青少年人工智能大赛县（区）选拔赛
            return `CERT_${eventCode}.png`;
        case 231006: // 香港线上赛
            return `CERT_${eventCode}.jpg`;
        case 231007: // 香港线下赛
            return "CERT_231006.jpg";
        default:
            return getDefaultTemplate(eventCode, prize);
    }
}

function getDefaultTemplate(eventCode, prize) {
    if (eventCode > 230000) {
        return `CERT_${eventCode}_${prize}.png`; 
    }
    return null;
}

// 根据图片模板返回不同的文字配置
export function getTemplateConfig(template) {

    // 添加证书TODO: 添加模板配置
    // 可用的属性：可以在myPage中添加
    /*
      prizeName: msgs.prizeName || "奖项名",
      name: (msgs.userLastNmae || "") + (msgs.userFirstName || ""),
      certificateNo: msgs.certificateNo,
      groupName: getGroupName(gameId),
      gameName: msgs.gameName || "", 
      signDate: createTime || "颁发日期",
      // signDate: msgs.signDate || "颁发日期",
      {
          font: css属性
          fillStyle: ctx.fillStyle
          textAlign: ctx.textAlign
          x, y 相对于模板的原始坐标
      }
    */
    // 芒果TV模版 mgtv_2023_1 ~ mgtv_2023_11, mgtv_2023_16, mgtv_2023_teacher
    if (template.startsWith("mgtv_2023_")){
        return {
            name: { font: "italic 72px 微软雅黑", fillStyle: "#4473b7", textAlign: "left", x: 898, y: 1782 },
            groupName: { font: "italic 88px 微软雅黑", fillStyle: "#4473b7", textAlign: "left", x: 878, y: 1662 },  
            certificateNo: { font: "italic 48px Arial", fillStyle: "#5483c7", textAlign: "right", x: 1600, y: 2333 },     
        }
    }
    switch (template) {
        case "level_accessment_1.png":
            return {
                certificateNo: { font: "54px Arial", fillStyle: "#E9A11C", textAlign: "left", x: 600, y: 267 },
                name: { font: "160px Arial", fillStyle: "#DB7A28", textAlign: "center", x: 1753, y: 1380 },
                signDate: { font: "60px Arial", fillStyle: "#DB7A28", textAlign: "center", x: 720, y: 2070 },
                groupEnName: { font: "96px Arial", fillStyle: "#DB7A28", textAlign: "center", x: 1725, y: 1675 },
                groupName: { font: "72px Arial", fillStyle: "#DB7A28", textAlign: "center", x: 1725, y: 1785 },
            };

        case "level_accessment_2.png":
        case "level_accessment_3.png":
        case "level_accessment_4.png":
        case "level_accessment_5.png":

            return {
                certificateNo: { font: "54px Arial", fillStyle: "#E9A11C", textAlign: "left", x: 600, y: 267 },
                name: { font: "160px Arial", fillStyle: "#004C8E", textAlign: "center", x: 1753, y: 1380 },
                signDate: { font: "60px Arial", fillStyle: "#004C8E", textAlign: "center", x: 720, y: 2070 },
                groupEnName: { font: "96px Arial", fillStyle: "#004C8E", textAlign: "center", x: 1725, y: 1675 },
                groupName: { font: "72px Arial", fillStyle: "#004C8E", textAlign: "center", x: 1725, y: 1785 },
            };

        case "sh202112python.jpg": // 2021年上海市小学生人工智能算法设计活动Python组别
            return {
                name: { font: "300px 微软雅黑", fillStyle: "black", textAlign: "center", x: 2480, y: 3500 },
                prizeName: { font: "320px 微软雅黑", fillStyle: "red", textAlign: "center", x: 2480, y: 4730 },
                certificateNo: { font: "72px 微软雅黑", fillStyle: "black", textAlign: "left", x: 1209, y: 6187 },
            };
        case "2021GlobalFinal.png": // 2021年全球赛新版证书
            return {
                name: { font: "100px Arial", fillStyle: "#636568", textAlign: "center", x: 1080, y: 1075 },
                groupName: { font: "100px Arial", fillStyle: "#636568", textAlign: "center", x: 1080, y: 1430 },
                prizeName: { font: "100px Arial", fillStyle: "#636568", textAlign: "center", x: 1080, y: 1775 },
                certificateNo: { font: "42px Arial", fillStyle: "#636568", textAlign: "left", x: 2380, y: 2212 },
            };
        case "2021GlobalFinal.jpg": // 2021年全球赛老版证书
            return {
                name: { font: "100px sans-serif", fillStyle: "#636568", textAlign: "center", x: 930, y: 1120 },
                groupName: { font: "100px sans-serif", fillStyle: "#636568", textAlign: "center", x: 930, y: 1470 },
                prizeName: { font: "100px sans-serif", fillStyle: "#636568", textAlign: "center", x: 930, y: 1820 },
                certificateNo: { font: "40px sans-serif", fillStyle: "#636568", textAlign: "left", x: 2320, y: 2276 },
            };

        case "sanqin_1.png": // 2022年三秦杯 金奖
            return {
                name: { font: "100px sans-serif", fillStyle: "#333", textAlign: "center", x: 1550, y: 1380 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1820, y: 1836 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1830, y: 1932 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1830, y: 2132 },
            };
        case "sanqin_2.png": // 2022年三秦杯 银奖
            return {
                name: { font: "100px sans-serif", fillStyle: "#333", textAlign: "center", x: 1665, y: 1120 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1970, y: 1670 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1970, y: 1760 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1970, y: 1964 },
            };
        case "sanqin_3.png": // 2022年三秦杯 铜奖
            return {
                name: { font: "100px sans-serif", fillStyle: "#333", textAlign: "center", x: 1666, y: 1065 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1965, y: 1610 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1965, y: 1706 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1965, y: 1920 },
            };
        case "sanqin_16.png": // 2022年三秦杯 明日之星
            return {
                name: { font: "100px sans-serif", fillStyle: "#333", textAlign: "center", x: 2304, y: 905 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2605, y: 1540 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2605, y: 1624 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2605, y: 1830 },
            };
        case "sanqin_final_1.png": // 2022年三秦杯 决赛 金奖 
            return {
                name: { font: "64px sans-serif", fillStyle: "#333", textAlign: "center", x: 942, y: 850 },
                groupName: { font: "38px sans-serif", fillStyle: "#333", textAlign: "center", x: 1130, y: 1144 },
            };
        case "sanqin_final_2.png": // 2022年三秦杯 决赛 银奖
            return {
                name: { font: "64px sans-serif", fillStyle: "#333", textAlign: "center", x: 1020, y: 690 },
                groupName: { font: "38px sans-serif", fillStyle: "#333", textAlign: "center", x: 1229, y: 1064 },
            };
        case "sanqin_final_3.png": // 2022年三秦杯 决赛 铜奖
            return {
                name: { font: "64px sans-serif", fillStyle: "#333", textAlign: "center", x: 1010, y: 655 },
                groupName: { font: "38px sans-serif", fillStyle: "#333", textAlign: "center", x: 1249, y: 1025 },
            };
        case "sanqin_final_16.png": // 2022年三秦杯 决赛 明日之星
            return {
                name: { font: "64px sans-serif", fillStyle: "#333", textAlign: "center", x: 1417, y: 556 },
                groupName: { font: "34px sans-serif", fillStyle: "#333", textAlign: "center", x: 1566, y: 963 },
            };

        case "220715G.jpg": // 西安编程向未来 金奖 
            return {
                name: { font: "70px sans-serif", fillStyle: "#333", textAlign: "center", x: 800, y: 680 },
                groupName: { font: "32px sans-serif", fillStyle: "#333", textAlign: "center", x: 992, y: 962 },
            };
        case "220715S.jpg": // 西安编程向未来 银奖
            return {
                name: { font: "70px sans-serif", fillStyle: "#333", textAlign: "center", x: 875, y: 590 },
                groupName: { font: "32px sans-serif", fillStyle: "#333", textAlign: "center", x: 1045, y: 966 },
            };
        case "220715B.jpg": // 西安编程向未来 铜奖
            return {
                name: { font: "70px sans-serif", fillStyle: "#333", textAlign: "center", x: 870, y: 560 },
                groupName: { font: "32px sans-serif", fillStyle: "#333", textAlign: "center", x: 1030, y: 960 },
            };

        case "shanxi2022-1.png": // 2022年山西预选赛 金奖
        case "ICode2022Gold.png": // 2022年ICode全国预选赛，尺寸：3333 x 2358
        case "ICode2022FinalGold.png": // 2022年ICode全国决赛，尺寸：3333 x 2358
            return {
                name: { font: "100px sans-serif", fillStyle: "#333", textAlign: "center", x: 1550, y: 1280 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1800, y: 1825 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1800, y: 1915 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1800, y: 2210 },
            };


        case "shanxi2022-2.png": // 2022年山西预选赛 银奖
        case "ICode2022Silver.png": // 2022年ICode全国预选赛 
        case "ICode2022FinalSilver.png": // 2022年ICode全国决赛，
            return {
                name: { font: "100px sans-serif", fillStyle: "#333", textAlign: "center", x: 1660, y: 1100 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 1655 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 1745 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 2037 },
            };


        case "shanxi2022-3.png": // 2022年山西预选赛 铜奖
        case "ICode2022Bronze.png": // 2022年ICode全国预选赛 
        case "ICode2022FinalBronze.png": // 2022年ICode全国决赛， 
            return {
                name: { font: "100px sans-serif", fillStyle: "#333", textAlign: "center", x: 1660, y: 1050 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 1592 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 1685 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 1980 },
            };


        case "GD202204.png": // 2022年广东预选赛 & 发明协会 明日之星
        case "shanxi2022-4.png": // 2022年山西预选赛 明日之星
        case "ICode2022Star.png": // 2022年ICode全国预选赛 
        case "ICode2022FinalStar.png": // 2022年ICode全国决赛
            return {
                name: { font: "100px sans-serif", fillStyle: "#333", textAlign: "center", x: 2280, y: 880 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2600, y: 1520 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2600, y: 1620 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2600, y: 1900 },
            };

        case "GD202201.png": // 2022年广东预选赛 & 发明协会 金奖
            return {
                name: { font: "100px sans-serif", fillStyle: "#333", textAlign: "center", x: 1500, y: 1230 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1800, y: 1825 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1800, y: 1915 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1800, y: 2210 },
            };

        case "GD202202.png": // 2022年广东预选赛 & 发明协会 银奖
            return {
                name: { font: "100px sans-serif", fillStyle: "#333", textAlign: "center", x: 1660, y: 1030 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 1655 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 1745 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 2037 },
            };

        case "GD202203.png": // 2022年广东预选赛 & 发明协会 铜奖
            return {
                name: { font: "100px sans-serif", fillStyle: "#333", textAlign: "center", x: 1660, y: 980 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 1610 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 1700 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 1980 },
            };

        case "v2020080801.png": // 2020年中国区决赛 金奖, 尺寸 3509 x 2481
        case "ICode2023P_Gold.png": // 2023年中国区预选赛 金奖，尺寸 3509 × 2481
        case "ICode2023F_Gold.png": // 2023年中国区决赛 金奖，尺寸 3509 × 2481
        case "ICode2024P_Gold.png": // 2024年中国区预选赛 金奖，尺寸 3509 × 2481
        case "CERT_240555_1.png": // 2024年中国区决赛赛 金奖，尺寸 3509 × 2481
        case "hn2023Gold.png":
            return {
                name: { font: "Bold 120px sans-serif", fillStyle: "#333", textAlign: "center", x: 1600, y: 1340 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1900, y: 1930 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1900, y: 2020 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1900, y: 2315 },
            };

        case "v2020080802.png": // 2020年中国区决赛 银奖
        case "ICode2023P_Silver.png": // 2023年中国区预选赛 银奖，尺寸 3509 × 2481
        case "ICode2023F_Silver.png": // 2023年中国区决赛 银奖，尺寸 3509 × 2481
        case "ICode2024P_Silver.png": // 2024年中国区预选赛 银奖，尺寸 3509 × 2481
        case "CERT_240555_2.png": // 2024年中国区决赛赛 银奖，尺寸 3509 × 2481
        case "hn2023Silver.png":
            return {
                name: { font: "Bold 120px sans-serif", fillStyle: "#333", textAlign: "center", x: 1760, y: 1150 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 1755 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 1848 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 2150 },
            };

        case "v2020080803.png": // 2020年中国区决赛 铜奖
        case "ICode2023P_Bronze.png": // 2023年中国区预选赛 铜奖，尺寸 3509 × 2481
        case "ICode2023F_Bronze.png": // 2023年中国区决赛 铜奖，尺寸 3509 × 2481
        case "ICode2024P_Bronze.png": // 2024年中国区预选赛 铜奖，尺寸 3509 × 2481
        case "CERT_240555_3.png": // 2024年中国区决赛赛 铜奖，尺寸 3509 × 2481
        case "hn2023Bronze.png":
        case "hn2023Star.png":
            return {
                name: { font: "Bold 120px sans-serif", fillStyle: "#333", textAlign: "center", x: 1760, y: 1090 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 1700 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 1790 },
                signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 2085 },
            };

        case "v2020080804.png": // 2020年中国区决赛 明日之星
        case "ICode2023P_Star.png": // 2023年中国区预选赛 明日之星，尺寸 3509 × 2481
        case "ICode2024P_Star.png": // 2024年中国区预选赛 明日之星，尺寸 3509 × 2481
        case "ICode2023F_Star.png": // 2023年中国区决赛 明日之星，尺寸 3509 × 2481
        case "CERT_240555_16.png": // 2024年中国区决赛赛 明日之星，尺寸 3509 × 2481
            return {
                name: { font: "100px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 2440, y: 950 },
                certificateNo: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 2720, y: 1620 },
                groupName: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 2720, y: 1708 },
                signDate: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 2720, y: 2005 },
            };
        case "hnai2023Gold.png": // 第一届湖南人工智能编程挑战赛 优异奖
        case "hnai2023Silver.png": // 第一届湖南人工智能编程挑战赛 优秀奖
        case "hnai2023Bronze.png": // 第一届湖南人工智能编程挑战赛 良好奖
            return {
                name: { font: "Bold 120px sans-serif", fillStyle: "#111", textAlign: "center", x: 635, y: 1520 },
                certificateNo: { font: "56px sans-serif", fillStyle: "#111", textAlign: "left", x: 1200, y: 3283 },
            };


            // 优秀组织奖
            // certificateNo: "21800436"
            // gameName: "2022预选赛（图形化初级）"
            // prizeName: "优秀组织铜奖"
            // schoolName: "龙港市第七小学"
            // signDate: "未知时间"
        case "org_220326.png": // 2022年优秀组织奖
        case "23030401_Org.jpg": // 2023年优秀组织奖
        case "org_24010000.png": // 2024年优秀组织奖
        case "org_23070000.jpg": // 2023年中国区决赛优秀组织奖
        case "org_24055500.png": // 2024年中国区决赛优秀组织奖
            return {
                prizeName: { font: "120px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1760, y: 1610 },
                certificateNo: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1930, y: 1750 },
                schoolName: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1930, y: 1860 },
            };

        case "org_24070900.png": 
            return {
                certificateNo: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1930, y: 1752 },
                schoolName: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1930, y: 1862 },
            };
            // 优秀指导教师
            // certificateNo: "21900477"
            // gameName: "第三届ICode预选赛（积木初级组）"
            // groupName: "图形化初级组"
            // name: "张安源"
            // prizeName: "优秀指导老师"
            // schoolName: "宿州市第一小学教育集团"

        case "teacher_220326.png": // 2022年优秀指导教师奖
        case "23030401_Teacher.jpg": // 2023年优秀指导教师奖
        case "teacher_23070000.jpg": // 2023中国区决赛
        case "teacher_23093001.jpg": // 2023 全球决赛
        case "teacher_24081801.jpg": // 2024 全球决赛
        case "teacher_24010000.jpg":
            return {
                prizeName: { font: "120px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1760, y: 1610 },
                certificateNo: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1930, y: 1750 },
                name: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1930, y: 1860 },
                schoolName: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1930, y: 1970 },
            };

        case "referee_20220001.png": // 2022年裁判员证书
            return {
                certificateNo: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1465, y: 1840 },
                name: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1465, y: 1550 },
                schoolName: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 1465, y: 1700 },
            };

        case "shx22103201A.jpg": // 2022西安智慧编程选拔赛 金奖, 尺寸 3509 x 2481
        case "shx22103202A.jpg":
        case "shx22103211A.jpg":
        case "shx22103212A.jpg":
        case "shx22122401A.jpg": // 2022西安智慧编程决赛 金奖, 尺寸 3509 x 2481
        case "shx22122402A.jpg":
        case "shx22122411A.jpg":
        case "shx22122412A.jpg":
            return {
                name: { font: "Bold 160px sans-serif", fillStyle: "#333", textAlign: "center", x: 1708, y: 1525 },
            };
        case "shx22103201B.jpg": // 2022西安智慧编程选拔赛 银奖
        case "shx22103202B.jpg":
        case "shx22103211B.jpg":
        case "shx22103212B.jpg":
        case "shx22122401B.jpg": // 2022西安智慧编程决赛 银奖
        case "shx22122402B.jpg":
        case "shx22122411B.jpg":
        case "shx22122412B.jpg":
            return {
                name: { font: "Bold 160px sans-serif", fillStyle: "#333", textAlign: "center", x: 1754, y: 1295 },
            };

        case "shx22103201C.jpg": // 2022西安智慧编程选拔赛 铜奖
        case "shx22103202C.jpg":
        case "shx22103211C.jpg":
        case "shx22103212C.jpg":
        case "shx22122401C.jpg": // 2022西安智慧编程决赛 铜奖
        case "shx22122402C.jpg":
        case "shx22122411C.jpg":
        case "shx22122412C.jpg":
            return {
                name: { font: "Bold 160px sans-serif", fillStyle: "#333", textAlign: "center", x: 1754, y: 1235 },
            };

        case "GlobalFinal2022_Gold.png": // 2022年全球赛 金奖
        case "GlobalFinal2022_Silver.png": // 2022年全球赛 银奖
        case "GlobalFinal2022_Bronze.png": // 2022年全球赛 铜奖
        case "GlobalFinal2022_Participation.png": // 2022年全球赛 明日之星
            return {
                name: { font: "100px 微软雅黑", fillStyle: "#636568", textAlign: "center", x: 1000, y: 1100 },
                certificateNo: { font: "45px 微软雅黑", fillStyle: "#636568", textAlign: "left", x: 2650, y: 2455 },
                groupName: { font: "100px 微软雅黑", fillStyle: "#636568", textAlign: "center", x: 1000, y: 1493 }
            };

        case "CERT_230930_1.jpg":
        case "CERT_230930_2.jpg":
        case "CERT_230930_3.jpg":
        case "CERT_240818_1.png":
        case "CERT_240818_2.png":
        case "CERT_240818_3.png":
            return {
                name: { font: "200px Verdana", fillStyle: "#4e4d4e", textAlign: "center", x: 2021, y: 1150 },
                prizeName: { font: "90px Bold Courier", fillStyle: "#4e4d4e", textAlign: "center", x: 2000, y: 1583 },
                groupName: { font: "84px Bold Courier", fillStyle: "#4e4d4e", textAlign: "center", x: 2000, y: 1755 },
                signDate:  { font: "90px Bold Courier", fillStyle: "#4e4d4e", textAlign: "center", x: 2000, y: 1923 },
                certificateNo: { font: "72px Bold Courier", fillStyle: "#4e4d4e", textAlign: "left", x: 750, y: 2280 },
            };
                 
        case "spring_certificate.png": // 2023新春赛 金奖, 尺寸 3509 x 2481
            return {
                name: { font: "Bold 180px sans-serif", fillStyle: "#f4e200", textAlign: "center", x: 1754, y: 910 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#f4e200", textAlign: "left", x: 1385, y: 2360 },
                groupName: { font: "140px sans-serif", fillStyle: "#f4e200", textAlign: "left", x: 1120, y: 1550 },
                prizeName: { font: "140px sans-serif", fillStyle: "#f4e200", textAlign: "right", x: 2385, y: 1550 },
                signDate: { font: "60px sans-serif", fillStyle: "#f4e200", textAlign: "left", x: 2170, y: 2360 },
            };
        case "221224_Teacher.jpg": // 西安决赛优秀教师证书 尺寸：3509 x 2481

            return {
                name: { font: "Bold 144px sans-serif", fillStyle: "#333", textAlign: "center", x: 1760, y: 1215 },
                certificateNo: { font: "68px sans-serif", fillStyle: "#333", textAlign: "center", x: 2090, y: 1790 },
            };
        case "221224_Org.jpg": // 西安决赛优秀组织证书 尺寸：3509 x 2481
            return {
                schoolName: { font: "Bold 130px sans-serif", fillStyle: "#333", textAlign: "center", x: 1760, y: 1215 },
                certificateNo: { font: "68px sans-serif", fillStyle: "#333", textAlign: "center", x: 2090, y: 1790 },
            };
        case "hnai2023Teacher.png": // 2023年湖南人工智能决赛优秀教师证书 尺寸：3509 x 2481
            return {
                name: { font: "Bold 140px sans-serif", fillStyle: "#333", textAlign: "center", x: 690, y: 1000 },
                prizeName: { font: "72px sans-serif", fillStyle: "#333", textAlign: "left", x: 533, y: 1448 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#aa7f31", textAlign: "left", x: 650, y: 2140 },
            };
        case "hnai2023School.png": // 2023年湖南人工智能决赛优秀教师证书 尺寸：3509 x 2481
            return {
                schoolName: { font: "Bold 140px sans-serif", fillStyle: "#333", textAlign: "center", x: 1755, y: 1050 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#aa7f31", textAlign: "left", x: 650, y: 2140 },
            };
        case "hnai2023PersonalA.png": // 2023年湖南人工智能决赛优秀教师证书 尺寸：3509 x 2481
        case "hnai2023PersonalB.png": // 2023年湖南人工智能决赛优秀教师证书 尺寸：3509 x 2481
        case "hnai2023PersonalC.png": // 2023年湖南人工智能决赛优秀教师证书 尺寸：3509 x 2481
        case "hnai2023PersonalS.png": // 2023年湖南人工智能决赛优秀教师证书 尺寸：3509 x 2481
            return {
                name: { font: "Bold 140px sans-serif", fillStyle: "#333", textAlign: "center", x: 672, y: 985 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#aa7f31", textAlign: "left", x: 650, y: 2140 },
            };
        case "nanjing_2023.png": // 2023南京选拔赛
        case "nanjing_2023p.png": // 2023 江苏南京选拔赛
            return {
                name: { font: "Bold 130px sans-serif", fillStyle: "#333", textAlign: "center", x: 2030, y: 1005 },
                prizeName: { font: "Bold 140px sans-serif", fillStyle: "#133279", textAlign: "center", x: 2060, y: 1470 },
                certificateNo: { font: "64px sans-serif", fillStyle: "#333", textAlign: "center", x: 1860, y: 1662 },
                groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1860, y: 1757 },
            };
            // 2023云南小学生比赛 4678 × 3308
        case "xxs2023_A.png":
        case "xxs2023_B.png":
        case "xxs2023_C.png":
        case "xxs2023_D.png":
        case "xxs2023_E.png":
            return {
                name: { font: "Bold 160px sans-serif", fillStyle: "#333", textAlign: "center", x: 2160, y: 1930 },
                // prizeName: { font: "Bold 140px sans-serif", fillStyle: "#133279", textAlign: "center", x: 2060, y: 1470 },
                certificateNo: { font: "80px sans-serif", fillStyle: "#333", textAlign: "center", x: 2580, y: 3090 },
                groupName: { font: "90px sans-serif", fillStyle: "#333", textAlign: "center", x: 2580, y: 2600 },
            };
        case "ICodeMaster2023.png":
            return {
                name: { font: "Bold 280px sans-serif", fillStyle: "#0d4175", textAlign: "center", x: 1230, y: 1300 },
                groupName: { font: "Bold 140px sans-serif", fillStyle: "#0d4175", textAlign: "right", x: 1540, y: 1760 },
                prizeName: { font: "Bold 140px sans-serif", fillStyle: "#0d4175", textAlign: "left", x: 1565, y: 1760 },
                signDate: { font: "60px sans-serif", fillStyle: "#0d4175", textAlign: "center", x: 622, y: 2190 },
                certificateNo: { font: "60px sans-serif", fillStyle: "#0d4175", textAlign: "center", x: 2890, y: 2190 },
            };
        case "CERT_230506_1.jpg":
            return {
                name: { font: "Bold 120px sans-serif", fillStyle: "#1d2b74", textAlign: "center", x: 1600, y: 1450 },
                groupName: { font: "66px sans-serif", fillStyle: "#1d2b74", textAlign: "center", x: 1940, y: 1950 },
            };
        case "CERT_230506_2.jpg":
            return {
                name: { font: "Bold 120px sans-serif", fillStyle: "#1d2b74", textAlign: "center", x: 1725, y: 1180 },
                groupName: { font: "66px sans-serif", fillStyle: "#1d2b74", textAlign: "center", x: 2120, y: 1810 },
            };
        case "CERT_230506_3.jpg":
            return {
                name: { font: "Bold 120px sans-serif", fillStyle: "#1d2b74", textAlign: "center", x: 1750, y: 1120 },
                groupName: { font: "66px sans-serif", fillStyle: "#1d2b74", textAlign: "center", x: 2130, y: 1750 },
            };
        case "CERT_230506_16.jpg":
            return {
                name: { font: "Bold 120px sans-serif", fillStyle: "#1d2b74", textAlign: "center", x: 2420, y: 940 },
                groupName: { font: "66px sans-serif", fillStyle: "#1d2b74", textAlign: "center", x: 2660, y: 1640 },
            };
        case "CERT_231006.jpg":
            return {
                certificateNo: { font: "Bold 56px SimSun", fillStyle: "#000", textAlign: "left", x: 2911, y: 315 },
                name: { font: "Bold 120px SimSun", fillStyle: "#000", textAlign: "center", x: 1780, y: 885 },
                prizeName: { font: "Bold 96px SimSun", fillStyle: "#000", textAlign: "center", x: 1640, y: 1280 },
                groupName: { font: "Bold 66px SimSun", fillStyle: "#000", textAlign: "center", x: 2030, y: 1470 },
                signDate: { font: "Bold 66px SimSun", fillStyle: "#000", textAlign: "center", x: 2030, y: 1613 },
                schoolName: { font: "Bold 66px SimSun", fillStyle: "#000", textAlign: "center", x: 2030, y: 1750 },
            }
        case "CERT_230302.png":
            return {
                name: { font: "Bold 120px sans-serif", fillStyle: "#000", textAlign: "center", x: 1700, y: 915 },
                prizeName: { font: "Bold 120px sans-serif", fillStyle: "#333", textAlign: "center", x: 1730, y: 1390 },
                certificateNo: { font: "Bold 60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 1900 },
                groupName: { font: "Bold 60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 2020 },
                signDate: { font: "Bold 60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1950, y: 2265 },
            };

        case "CERT_230919_1.jpg": // 浙江迎亚运
        case "CERT_230919_2.jpg":
        case "CERT_230919_3.jpg":
        case "CERT_231204_1.jpg":
        case "CERT_231204_2.jpg":
        case "CERT_231204_3.jpg":
            return {
                name: { font: "54px 微软雅黑", fillStyle: "#232670", textAlign: "center", x: 904, y: 612 },
                certificateNo: { font: "30px 微软雅黑", fillStyle: "#232670", textAlign: "center", x: 1033, y: 924 },
                groupName: { font: "30px 微软雅黑", fillStyle: "#232670", textAlign: "center", x: 1033, y: 976 },
                signDate: { font: "30px 微软雅黑", fillStyle: "#232670", textAlign: "center", x: 1033, y: 1083 },
            }
        default:
            return getDefaultTemplateConfig(template);
    }
}

// 增加默认证书配置 以 CERT_EVENTCODE_PRIZE.png 开头
function getDefaultTemplateConfig(template){

    const regex_gold = /CERT_\d+_1.png/g;
    const regex_silver = /CERT_\d+_2.png/g;
    const regex_bronze = /CERT_\d+_3.png/g;
    const regex_star = /CERT_\d+_16.png/g;

    if(template.match(regex_gold)) {
        return {
            name: { font: "Bold 120px sans-serif", fillStyle: "#333", textAlign: "center", x: 1600, y: 1340 },
            certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1900, y: 1930 },
            groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1900, y: 2020 },
            signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 1900, y: 2315 },
        };
    } else if(template.match(regex_silver)) {
        return {
            name: { font: "Bold 120px sans-serif", fillStyle: "#333", textAlign: "center", x: 1760, y: 1150 },
            certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 1755 },
            groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 1848 },
            signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 2150 },
        };
    } else if(template.match(regex_bronze)) {
        return {
            name: { font: "Bold 120px sans-serif", fillStyle: "#333", textAlign: "center", x: 1760, y: 1090 },
            certificateNo: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 1700 },
            groupName: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 1790 },
            signDate: { font: "60px sans-serif", fillStyle: "#333", textAlign: "center", x: 2050, y: 2085 },
        };
    } else if (template.match(regex_star)) {
        return {
            name: { font: "100px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 2440, y: 950 },
            certificateNo: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 2720, y: 1620 },
            groupName: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 2720, y: 1708 },
            signDate: { font: "60px 微软雅黑", fillStyle: "#333", textAlign: "center", x: 2720, y: 2005 },
        };
    }

    return null;
}


// WEBPACK FOOTER //
// ./src/utils/certificationCfg.js